module.exports = __webpack_public_path__ + "static/media/wavm8s-005-dj-mare.7cea610.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-005-dj-mare.mp3
// module id = mSbD
// module chunks = 0